import { createApp } from 'vue'
import axios from 'axios';
import App from '@/App.vue'
import router from '@/router.js'
import store from '@/store.js'
import './registerServiceWorker'

//axios.defaults.baseURL = 'http://localhost';
axios.defaults.baseURL = 'https://cozybox.online';
createApp(App).use(store).use(router).mount('#app')
